"use client"

import { useState } from "react"
import { Download, Loader2 } from "lucide-react"

import { buttonVariants } from "@/components/ui/button"
import type { MobileAppLandingInfo } from "@/lib/mobile-app"
import { cn } from "@/lib/utils"

type MobileAppDownloadButtonProps = {
  landing: MobileAppLandingInfo
  className?: string
  size?: "default" | "lg"
}

export function MobileAppDownloadButton({
  landing,
  className,
  size = "lg",
}: MobileAppDownloadButtonProps) {
  const [pending, setPending] = useState(false)

  function handleDownload() {
    if (pending || !landing.has_apk) return
    setPending(true)
    const link = document.createElement("a")
    link.href = landing.apk_url
    link.rel = "noopener"
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.setTimeout(() => setPending(false), 800)
  }

  const disabled = pending || !landing.has_apk

  return (
    <button
      type="button"
      disabled={disabled}
      onClick={handleDownload}
      title={
        landing.has_apk
          ? `Скачать ${landing.download_filename}`
          : "APK ещё не загружен в админке MobileApp → Настройки"
      }
      className={cn(
        buttonVariants({
          variant: "info",
          size,
          className: "gap-1.5 whitespace-nowrap",
        }),
        className,
      )}
    >
      {pending ? (
        <Loader2 className="h-4 w-4 shrink-0 animate-spin" />
      ) : (
        <Download className="h-4 w-4 shrink-0" />
      )}
      {landing.has_apk ? "Скачать APK" : "Скоро будет доступно"}
    </button>
  )
}
